/* eslint-disable no-irregular-whitespace */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Nav from '../../components/Nav'

class Privacy extends Component {
  render () {
    return (
      <div>
        <div className='container mx-auto pt-8 pb-8'>
          <Nav />
        </div>
        <div className='bg-upton-100 pt-8 pb-8'>
          <div className='flex-1 flex flex-col items-center justify-center'>
            <h2 className='text-white text-xl lg:text-6xl font-thin'>Privacy Policy</h2>
          </div>

        </div>

        <div className='w-100 min-h-screen bg-gradient-to-b to-black from-gray-1400 relative pt-12 pb-12'>
          <div className='container text-white mx-auto p-6 text-xl terms'>
            <h2>Our contact details</h2>
            <ul>
              <li>Name: Upton Priory PTFA</li>
              <li>Address: Berwick Cl, Cheshire East Macclesfield SK10 3ED</li>
              <li>E-mail: <a href='mailto:ptfa@uptonpriory.cheshire.sch.uk'>ptfa@uptonpriory.cheshire.sch.uk</a></li>

            </ul>

            <h2>The type of personal information we collect</h2>
            <p>We currently collect and process the following information:</p>
            <ul>
              <li>Name</li>
              <li>Email</li>
              <li>Phone number</li>
            </ul>

            <h2>How we use your data</h2>
            <p>Upton Priory PTFA require this information in order to provide you with your ticket numbers and inform you if you have won any prizes. If you do not wish to provide this information, unfortunately you will not be able to participate in the raffle.</p>
            {/* <p>The lawful basis for the collection and processing of your personal data by and on behalf of the Data Controller under Article 6 of the GDPR is that you have provided your direct consent via the opt-in tick box on the raffle website.</p> */}
            <p>It is in the legitimate interests of the Data Controller to collect and process your process your personal data as the raffle could not be operated successfully for your benefit without such data processing, and your rights and freedoms are not prejudiced by this.</p>
            <p>Your personal data will only be retained for as long as is necessary to enable your participation in the raffle. </p>
            {/* <p>You have a number of legal rights in respect of your personal data under the GDPR which include : the right to be informed about how it is being used and why; the right of access to it to check that we are acting lawfully and, in some cases, the right to rectify it or to have it erased; the right to restrict our processing of it and the right of data portability.</p> */}

            <h2>How we store your personal information</h2>
            <p>Your information is securely stored in a database in Ireland operated by Amazon Web Services. </p>
            <p>We keep your name, email, phone number for 1 year. We will then dispose your information by deleting the database.</p>

            <h2>Your data protection rights</h2>
            <p>Under data protection law, you have rights including:</p>
            <li>Your right of access - You have the right to ask us for copies of your personal information.</li>
            <li>Your right to rectification - You have the right to ask us to rectify personal information you think is inaccurate. You also have the right to ask us to complete information you think is incomplete.</li>
            <li>Your right to erasure - You have the right to ask us to erase your personal information in certain circumstances.</li>
            <li>Your right to restriction of processing - You have the right to ask us to restrict the processing of your personal information in certain circumstances.</li>
            <li>Your right to object to processing - You have the the right to object to the processing of your personal information in certain circumstances.</li>
            <li>Your right to data portability - You have the right to ask that we transfer the personal information you gave us to another organisation, or to you, in certain circumstances.</li>
            <p>You are not required to pay any charge for exercising your rights. If you make a request, we have one month to respond to you.</p>
            <p>Please contact us at <a href='mailto:ptfa@uptonpriory.cheshire.sch.uk'>ptfa@uptonpriory.cheshire.sch.uk</a>  if you wish to make a request.</p>

            <h2>How to complain</h2>
            <p>If you have any concerns about our use of your personal information, you can make a complaint to us at <a href='mailto:ptfa@uptonpriory.cheshire.sch.uk'>ptfa@uptonpriory.cheshire.sch.uk</a>.</p>
            <p>You can also complain to the ICO if you are unhappy with how we have used your data.</p>
            <p>The ICO’s address:</p>
            <p>Information Commissioner’s Office<br />
              Wycliffe House<br />
              Water Lane<br />
              Wilmslow<br />
              Cheshire<br />
              SK9 5AF</p>

            <p>Helpline number: 0303 123 1113</p>
            <p>ICO website: https://www.ico.org.uk</p>

          </div>

        </div>

      </div>

    )
  }
};

const mapStateToProps = ({ data }) => ({
  data
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Privacy))
